/* eslint-disable react/jsx-indent-props */
import React from "react";
import { useStore } from "react-redux";
import { useStores } from "../use.store";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Div100vh from "react-div-100vh";

const Layout = observer(({ children }) => {
  const { generalStore } = useStores();
  const listMenu = [
    {
      name: "WayFinder",
      slug: "wayfinder",
    },
    {
      name: "More Information",
      slug: "get-info",
    },
  ];
  const navigate = useHistory();

  return (
    <Div100vh>
      <div className="w-full h-full flex flex-col relative">
        <div className="h-full w-full overflow-hidden">{children}</div>
        <div class="fixed flex flex-row bottom-4 left-1/2 transform -translate-x-1/2 bg-white text-[#D4D4D4] px-8 py-2 rounded-full z-20 gap-12 shadow-[0px_4px_24px_0px_#0000001F] w-max md:w-[450px] md:gap-x-16 justify-around">
          {listMenu.map((e) => {
            return (
              <div
                key={e["slug"]}
                className="flex flex-col md:flex-row lg:flex-row items-center justify-center md:gap-x-3"
                onClick={() => {
                  navigate.replace(`/${e.slug}`, { replace: true });
                }}
              >
                <img
                  src={require(`../assets/images/nav/${e["slug"]}-${
                    e.slug == generalStore.activePage ? "active" : "inactive"
                  }.svg`)}
                  className="w-[24px] h-[24px] md:w-10 md:h-10"
                />
                <span
                  className={`text-[10px] md:text-[16px] !important ${
                    e.slug == generalStore.activePage
                      ? "font-bold text-[#444444]"
                      : "font-light text-gray-300	"
                  }`}
                >
                  {e.name}
                </span>
              </div>
            );
          })}
        </div>
        {/* <div className="grid grid-cols-4 gap-2 h-full">
            {listMenu.map((e) => {
              return (
                <div
                  key={e["slug"]}
                  className="flex flex-col items-center justify-center"
                  onClick={() => {
                    navigate.push(e.slug);
                    // generalStore.from = null;
                    // generalStore.to = null;
                  }}
                >
                  <img
                    src={require(`../assets/images/nav/${e["slug"]}-${
                      e.slug == generalStore.activePage ? "active" : "inactive"
                    }.svg`)}
                    className="w-8 h-8"
                  />
                  <span
                    className={`text-[10px] ${
                      e.slug == generalStore.activePage
                        ? "font-bold text-primary"
                        : "font-light text-gray-300	"
                    }`}
                  >
                    {e.name}
                  </span>
                </div>
              );
            })}
          </div> */}
        {/* </div> */}
      </div>
    </Div100vh>
  );
});

export default Layout;
